import { gql } from "@apollo/client";

export const GET_NOTIFICATION_BY_ID = gql`
query GetNotificationSetting {
  getNotificationSetting {
    data {
      _id
      doctorId
      emailNotification
      enrollments {
        dataTypeId
        isNotify
      }
      locations
      smsNotification
      webappNotification
    }
    message
  }
}
`;

export const GET_ALL_NOTIFICATION = gql`
  query GetAllNotifications($filters: GetNotificationsInput) {
    getAllNotifications(filters: $filters) {
      message
      notifications {
        _id
        body
        createdAt
        date
        doctorId
        patientId
        medium
        subject
        updatedAt
        markAsRead
      }
      pagination {
        total
        hasNextPage
      }
    }
  }
`;
